<p-dialog
  header="Add Sample PO Lines"
  [position]="'center'"
  appendTo="body"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [visible]="dialogVisible()"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{
    width: '1551px',
    height: '993px',
    'max-width': '95vw',
    'max-height': '95vh',
    'border-radius': '10px',
  }">
  <div class="d-flex align-items-center gap-2 mb-3">
    <p class="m-0">Select sample POs</p>
    @if (loadingLineItems()) {
      <jni-spinner />
    }
  </div>

  <!-- Sample POs Table -->
  <p-table
    [value]="samplePOs()"
    [size]="'small'"
    [(selection)]="selectedSamplePOs"
    (selectionChange)="onSamplePoSelectionChange()"
    [loading]="loadingSamplePOs()"
    dataKey="purchaseOrderNumber"
    styleClass="p-datatable-sm proposal-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>Sample PO #</th>
        <th>Vendor Name</th>
        <th>Job Name</th>
        <th>Client Name</th>
        <th>BC Name</th>
        <th>Status</th>
        <th>Created By</th>
        <th>Created Date</th>
        <th>Project ID</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-samplePo>
      <tr>
        <td>
          <p-tableCheckbox [value]="samplePo" />
        </td>
        <td>{{ samplePo.purchaseOrderNumber }}</td>
        <td>{{ samplePo.vendorName }}</td>
        <td>{{ samplePo.jobName }}</td>
        <td>{{ samplePo.customerName }}</td>
        <td>{{ samplePo.bcName }}</td>
        <td>{{ samplePo.status }}</td>
        <td>{{ samplePo.createdBy }}</td>
        <td>{{ samplePo.createdDate | date: "MM-dd-yyyy" }}</td>
        <td>{{ samplePo.projectId }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="10" class="text-center py-3">
          No sample POs found for this client
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Paginator -->
  <p-paginator
    [rows]="rows"
    [totalRecords]="totalRecords()"
    [first]="first"
    (onPageChange)="onPageChange($event)"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{first} of {totalRecords}">
  </p-paginator>

  <!-- Select Line Items Section -->
  <h3 class="mt-4 mb-3 fw-semibold">Select Line Items</h3>

  <p-table
    [value]="lineItems()"
    [size]="'small'"
    [(selection)]="selectedLineItems"
    dataKey="id"
    styleClass="p-datatable-sm line-items-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 3rem">
          <p-tableHeaderCheckbox />
        </th>
        <th>Sample PO #</th>
        <th>Line #</th>
        <th>Vendor SKU</th>
        <th>Description</th>
        <th>Category</th>
        <th>Ship Date</th>
        <th>In-Hands Date</th>
        <th>Quantity</th>
        <th>Net</th>
        <th>Net Total</th>
        <th>Status</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td>
          <p-tableCheckbox [value]="item" />
        </td>
        <td>{{ item.purchaseOrderNumberD365 }}</td>
        <td>{{ item.lineNumberD365 }}</td>
        <td>{{ item.externalItemNumberD365 }}</td>
        <td>{{ item.lineDescriptionD365 }}</td>
        <td>{{ item.projectCategoryIdD365 }}</td>
        <td>{{ item.requestedShippingDateD365 | date: "MM-dd-yyyy" }}</td>
        <td>{{ item.requestedDeliveryDateD365 | date: "MM-dd-yyyy" }}</td>
        <td>{{ item.orderedPurchaseQuantityD365 }}</td>
        <td>{{ item.purchasePriceD365 | number: "1.2-4" }}</td>
        <td>{{ item.lineAmountD365 | number: "1.2-2" }}</td>
        <td>{{ item.status }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="12" class="text-center py-3">
          Select one or more sample POs to view their line items
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="d-flex justify-content-end gap-2 pt-4">
    <p-button
      label="Cancel"
      (click)="closeModal()"
      variant="outlined"
      severity="secondary" />
    <p-button
      label="Save"
      [disabled]="selectedLineItems.length === 0"
      (click)="save()" />
  </div>
</p-dialog>
